export default __webpack_public_path__ + "static/media/dining3.f8c03de6.JPG";